import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

const BILLING_OPTIONS = [
  { value: "invoiced", label: "Faturalı", hint: "Fatura kalemleriyle" },
  { value: "non_invoiced", label: "Faturasız", hint: "Bedeli elle girin" },
];

// Zorunlu Faturalı / Faturasız seçim kartları (başlangıçta seçim yok). Yeni İş + Yeni Satın Alma.
export function BillingChoice({ value, onChange, className = "", testIdPrefix = "job-billing", nonInvoicedHint }) {
  return (
    <div className={`space-y-1.5 ${className}`} role="radiogroup" aria-label="Faturalandırma"
         data-testid={`${testIdPrefix}-choice`}>
      <Label className="text-xs">Faturalandırma *</Label>
      <div className="grid grid-cols-2 gap-2">
        {BILLING_OPTIONS.map((o) => {
          const selected = value === o.value;
          const hint = o.value === "non_invoiced" && nonInvoicedHint ? nonInvoicedHint : o.hint;
          return (
            <button key={o.value} type="button" role="radio" aria-checked={selected}
                    onClick={() => onChange(o.value)} data-testid={`${testIdPrefix}-${o.value}`}
                    className={cn(
                      "min-h-10 rounded-lg border px-3 py-1.5 text-left transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-slate-400",
                      selected ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-700 hover:border-slate-400",
                    )}>
              <span className="block text-sm font-medium leading-tight">{o.label}</span>
              <span className={cn("block text-[11px] leading-tight", selected ? "text-white/70" : "text-slate-400")}>{hint}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
